var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.spread)?_c('div',{staticClass:"container-flex"},[_c('h3',[_vm._v("Spread "+_vm._s(_vm.spread.label))]),_c('AnnotatedImage',{attrs:{"image_url":_vm.spread.image.web_url,"points":_vm.annotation}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }